<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: v =>
      [
        'active',
        'sending',
        'scheduled',
        'success',
        'partial',
        'failed',
        'disabled',
        'retrying',
      ].includes(v), // GK-HUB: R6
  },
});

const { t } = useI18n();

const CONFIG = {
  active: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.ACTIVE',
    classes: 'bg-n-teal-3 text-n-teal-11 border-n-teal-6',
    dot: 'bg-n-teal-9',
  },
  sending: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.SENDING',
    classes: 'bg-n-blue-3 text-n-blue-11 border-n-blue-6',
    dot: 'bg-n-blue-9 animate-pulse',
  },
  scheduled: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.SCHEDULED',
    classes: 'bg-n-amber-3 text-n-amber-11 border-n-amber-6',
    dot: 'bg-n-amber-9',
  },
  success: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.SUCCESS',
    classes: 'bg-n-teal-3 text-n-teal-11 border-n-teal-6',
    dot: 'bg-n-teal-9',
  },
  partial: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.PARTIAL',
    classes: 'bg-n-amber-3 text-n-amber-11 border-n-amber-6',
    dot: 'bg-n-amber-9',
  },
  failed: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.FAILED',
    classes: 'bg-n-ruby-3 text-n-ruby-11 border-n-ruby-6',
    dot: 'bg-n-ruby-9',
  },
  disabled: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.DISABLED',
    classes: 'bg-n-solid-3 text-n-slate-9 border-n-weak',
    dot: 'bg-n-slate-7',
  },
  // GK-HUB: R6 — Retrying status
  retrying: {
    label: 'CAMPAIGN.DASHBOARD.STATUS.RETRYING',
    classes: 'bg-n-amber-3 text-n-amber-11 border-n-amber-6',
    dot: 'bg-n-amber-9 animate-pulse',
  },
};

const config = computed(() => CONFIG[props.status] || CONFIG.active);
</script>

<template>
  <span
    class="inline-flex items-center gap-1.5 px-2 py-0.5 text-xs font-medium rounded-full border whitespace-nowrap"
    :class="config.classes"
  >
    <span class="w-1.5 h-1.5 rounded-full" :class="config.dot" />
    {{ t(config.label) }}
  </span>
</template>
